export default __webpack_public_path__ + "5d87c2c73f40b15a2aa3226cd007f424.svg";